module.exports = __webpack_public_path__ + "static/media/left_icon_blue.3b31027b.svg";